// generated by tools/copy-monaco.mjs — do not edit
export const MONACO_VERSION = '0.52.2';
